import React, { useEffect, useState } from "react";
import { get, map } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { countryDropdownOptions } from "../../v2_actions/dropdown_options";
import { useGalleryFilterSearchParams } from "./useGalleryFilterSearchParams";
import { useEventPageContext } from "./EventPageContext";
import { styles } from "./styles";
import { makeLogger } from "../../utils/logger";

const logger = makeLogger({
  enabled: true,
  label: "FilterCountry",
  color: "pink",
});

const DEFAULT_COUNTRY = {
  label: "Australia",
  value: "f57f2201-0af1-4810-bdba-e483992e5229",
};

export default function FilterCountry() {
  useSelector(() => ({})); // force redux state reconcile
  const dispatch = useDispatch();
  const eventPageCtx = useEventPageContext();
  const [galleryFilterSearchParams, syncGalleryFilterSearchParam] =
    useGalleryFilterSearchParams();
  const [muiMenuAnchor, setMuiMenuAnchor] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = useState(1);
  //const [countryOption, setCountryOption] = useState(null);
  const isMenuOpen = Boolean(muiMenuAnchor);

  // TODO: relies on /api/v2/customer/dropdown_options/countries/? API
  const countryOptions = countryDropdownOptions.getAsOptions();

  const countryFilterFromSearchParam = galleryFilterSearchParams.country;

  logger.log("render()", countryFilterFromSearchParam, countryOptions);

  useEffect(() => {
    dispatch(countryDropdownOptions.updatePaginationNumItemsPerPage(1000));
    dispatch(countryDropdownOptions.fetchListIfNeeded({ callSource: 'FilterCountry' }));
  }, []);

  useEffect(() => {
    logger.log("FX: countryOptions", countryOptions);
    const country =
      countryFilterFromSearchParam || get(DEFAULT_COUNTRY, "value");
    
      // TODO: [param may be wrong for country]
    eventPageCtx.updateListFilter({
      country,
      _callSource: "Filterountry",
    });
  }, [countryFilterFromSearchParam]);

  const handleClickListItem = (event) => {
    setMuiMenuAnchor(event.currentTarget);
  };

  const handleMenuItemClick = (option, index) => {
    syncGalleryFilterSearchParam("country", option?.value);
    setMuiMenuAnchor(null);
  };

  const handleClose = () => {
    setMuiMenuAnchor(null);
  };

  const label = countryOptions
    .filter((opt) => opt.value === countryFilterFromSearchParam)
    .map((opt) => opt.label)
    .concat(get(DEFAULT_COUNTRY, "label"))
    .shift();

  return (
    <div>
      <List
        component="nav"
        aria-label="Device settings"
        sx={styles.filterList}>
        <ListItem
          button
          sx={styles.filterListItem}
          aria-expanded={isMenuOpen ? "true" : undefined}
          onClick={handleClickListItem}>
          <ListItemText
            primary="Country"
            sx={styles.filterListItemText}
            secondary={
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox disabled defaultChecked />}
                  label={label}
                />
              </FormGroup>
            }
          />
        </ListItem>
      </List>
      <Menu
        id="lock-menu"
        anchorEl={muiMenuAnchor}
        open={isMenuOpen}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}>
        <MenuItem
          value={null}
          disabled={countryFilterFromSearchParam === null}
          selected={countryFilterFromSearchParam === null}
          onClick={(event) => handleMenuItemClick(null, 0)}>
          All
        </MenuItem>
        {map(countryOptions, (option, index) => (
          <MenuItem
            key={get(option, "value")}
            disabled={countryFilterFromSearchParam === get(option, "value")}
            selected={countryFilterFromSearchParam === get(option, "value")}
            onClick={(event) => handleMenuItemClick(option, index)}>
            {get(option, "label")}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
